import { useDispatch, useSelector } from "react-redux";
import { sendChatPrelogin } from "../services/chatService.js";
import { formatMessageData } from "../utils/formatData.js";
import {
    concatMessage,
    incrementPosition,
    updateExpiredAt,
} from "../features/messagesSlice.js";

export default function useSendData() {
    const dispatch = useDispatch();
    const position = useSelector((state) => state.messages.position);
    const deviceId = useSelector((state) => state.session.deviceId);
    const sKey = useSelector((state) => state.session.sKey);
    const token = useSelector((state) => state.session.token);

    const sendMessage = async (userInput, userInputType = "normal") => {
        if (!userInput) return;

        let finalMessageData;

        finalMessageData = formatMessageData(
            deviceId,
            "user",
            userInput,
            position,
            userInputType
        );

        dispatch(concatMessage(finalMessageData));
        dispatch(incrementPosition());
        dispatch(updateExpiredAt());

        await sendMessageToAI(userInput);
    };

    const sendMessageToAI = async (userInput) => {
        try {
            await sendChatPrelogin(
                deviceId,
                token,
                sKey,
                userInput,
                position + 1,
                dispatch
            );
            dispatch(incrementPosition());
        } catch (error) {
            return "An error has occurrred, please try again later.";
        }
    };

    return { sendMessage };
}
